import React from 'react'

type List = Array<string | React.ReactNode>

export const SUMMARY_HINTS: List = [
  <>
    <strong>Praktik Kinerja</strong> yang dipilih cocok untuk difokuskan di
    satuan pendidikan
  </>,
  <>
    <strong>Pengembangan Kompetensi</strong> yang dipilih mendukung peningkatan
    Indikator
  </>,
  <>
    <strong>Perilaku Kerja</strong> yang dipilih sesuai
  </>,
]
